module.exports = __webpack_public_path__ + "media/images/cement-wrp-a7c703ba5b8841d427117a842e45db86.jpg";